module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.bafb105.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Regular.woff
// module id = +dl7
// module chunks = 10